module.exports = __webpack_public_path__ + "img/6.e9ed77e0.jpg";